import moment from 'moment-timezone';
import { useClient } from '../ClientProvider';
import useQuery from '../useQuery';
import useConvertedValue from './useConvertedValue';
const useCumulativeSeasonalIrrigation = (plot) => {
    const client = useClient();
    const { convertValue } = useConvertedValue();
    const period = {
        since: moment().tz(plot.timezone).startOf('year').unix(),
        // end of current day
        before: moment().tz(plot.timezone).endOf('day').unix()
    };
    const cumulativeSeasonalIrrigationRequest = useQuery(client.measurementsReports.getCumulativeSum({
        ...period,
        plotId: plot.id,
        metrics: ['IRR']
    }));
    const cumulativeIrrigation = cumulativeSeasonalIrrigationRequest.data?.cumul;
    const formattedTotal = convertValue({
        value: cumulativeIrrigation,
        metric: 'irrigation'
    });
    // May be available for drip irrigation
    // const averageDosePerIrrigation = isNil(cumulativeSeasonalIrrigationRequest.data)
    //   ? undefined
    //   : cumulativeSeasonalIrrigationRequest.data.cumul / cumulativeSeasonalIrrigationRequest.data.count
    return {
        cumulativeIrrigation: formattedTotal,
        cumulativeSeasonalIrrigationRequest,
        period
    };
};
export default useCumulativeSeasonalIrrigation;
